module.exports = __webpack_public_path__ + "odstraneni-tetovaze_7_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/odstraneni-tetovaze_7_after_tn.jpg
// module id = 1431
// module chunks = 0